import { TFetchConverter } from 'data/types/converter.types';
import {
  TAccessCodeRowDB,
  TAccessCodeRowUI,
  TAccessCodesTableDB,
  TAccessCodesTableUI,
  TCoveringAccessCodesDB,
  TCoveringAccessCodesUI,
  TGetAccessCodeDB,
  TGetAccessCodeUI,
} from 'data/types/accessCode.types';
import { b64toBlob } from 'helpers/fileServices';
import { fileConverter } from './general.converters';
import { pageableDataConverter } from './pagableData.converters';

export const accessCodeRowConverter: TFetchConverter<TAccessCodeRowUI, TAccessCodeRowDB> = {
  fromDb: (data) => ({
    id: data.id,
    name: data.name,
    code: data.code,
    link: data.link,
    isAllProperties: data.isAllProperties,
    isCustomPropertyAllowed: data.isCustomPropertyAllowed,
    canEdit: data.canEdit ?? null,
    assignedProperties: (data.assignedProperties || []).map((property) => ({
      id: property.id,
      name: property.name,
    })),
  }),
};

export const accessCodesTableConverter: TFetchConverter<TAccessCodesTableUI, TAccessCodesTableDB> = {
  fromDb: (data) => {
    const { content, ...pagination } = data.accessCodes;
    return {
      defaultAccessCode: data.defaultAccessCode ? accessCodeRowConverter.fromDb(data.defaultAccessCode) : null,
      content: (content || []).map((item) => accessCodeRowConverter.fromDb(item)),
      paginationData: pageableDataConverter.fromDb(pagination),
    };
  },
};

export const coveringAccessCodesConverter: TFetchConverter<TCoveringAccessCodesUI, TCoveringAccessCodesDB> = {
  fromDb: (data) => ({
    accessCodes: (data.accessCodes || []).map((item) => accessCodeRowConverter.fromDb(item)),
    allPropertiesAccessCodeHidden: data.allPropertiesAccessCodeHidden,
  }),
};

export const accessCodeConverter: TFetchConverter<TGetAccessCodeUI, TGetAccessCodeDB> = {
  fromDb: (data) => {
    const qrFile = b64toBlob(data.qr, 'image/png');
    return {
      name: data.name,
      code: data.code,
      link: data.link,
      qr: URL.createObjectURL(qrFile),
      signUpSheet: fileConverter.fromDb(data.signUpSheet),
      signUpSheetEs: fileConverter.fromDb(data.signUpSheetEs),
      isAllProperties: data.isAllProperties,
      assignedProperties: (data.assignedProperties || []).map((property) => ({
        id: property.id,
        name: property.name,
      })),
    };
  },
};
